import React from "react"
import { Link } from "gatsby"

export const FooterColumn = ({
  title,
  link,
  column_items,
  paragraph,
  highlighted_text,
}) => {
  return (
    <div className="column">
      <div
        className="is-flex is-flex-direction-column"
        style={{ height: "100%" }}
      >
        {!!link ? (
          <Link to={link} className="title is-4 is-size-5-touch">
            <div dangerouslySetInnerHTML={{ __html: title }}></div>
          </Link>
        ) : (
          <div
            className="title is-4 is-size-5-touch"
            dangerouslySetInnerHTML={{ __html: title }}
          ></div>
        )}

        {paragraph ? <p className="mb-4">{paragraph}</p> : null}
        {highlighted_text ? (
          <p className="mb-4 has-text-weight-bold has-text-sonnengelb">
            {highlighted_text}
          </p>
        ) : null}
        <ul>
          {column_items.map(({ link, label, href }, index) => {
            return (
              <li className="pt-0" key={`column-item-${label}-${index}`}>
                {link ? (
                  <Link to={link}>{label}</Link>
                ) : (
                  <a href={href} target="_blank" rel="noopener noreferrer">
                    {label}
                  </a>
                )}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
